import { SignUp as ClerkSignUp, useAuth } from "@clerk/react";
import { Link, Navigate } from "react-router-dom";
import { AuthMarketingLayout } from "@/components/AuthMarketingLayout";
import { AuthLoadingState } from "@/features/auth/ProtectedRoute";

export function SignUp() {
  const { isLoaded, isSignedIn } = useAuth();

  if (!isLoaded) {
    return <AuthLoadingState />;
  }

  if (isSignedIn) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <AuthMarketingLayout
      title="Create account"
      legalNotice={
        <>
          By creating an account, you agree to the{" "}
          <Link to="/terms" className="font-semibold text-indigo-700 hover:text-indigo-900">
            Terms of Use
          </Link>{" "}
          and acknowledge the{" "}
          <Link to="/privacy" className="font-semibold text-indigo-700 hover:text-indigo-900">
            Privacy Policy
          </Link>
          .
        </>
      }
      accountSwitch={
        <>
          Already have an account?{" "}
          <Link to="/sign-in" className="font-semibold text-indigo-700 hover:text-indigo-900">
            Sign in
          </Link>
        </>
      }
    >
      <ClerkSignUp
        routing="path"
        path="/sign-up"
        signInUrl="/sign-in"
        fallbackRedirectUrl="/dashboard"
        appearance={{
          elements: {
            rootBox: "w-full",
            cardBox: "w-full shadow-none",
            card: "w-full shadow-none",
          },
        }}
      />
    </AuthMarketingLayout>
  );
}
